const isFinture = window.location.href.indexOf('planejamento.finture.app') !== -1

export const finture = () => {

    return isFinture
}